import type { Translations } from '../../../types'

const profileUserEditorMessages: Translations = {
  "profile.userEditor.header.createTitle": "Nuovo utente",
  "profile.userEditor.header.editTitle": "Dettagli utente",
  "profile.userEditor.header.createSubtitle": "Configura profilo, ruoli e permessi",
  "profile.userEditor.header.editSubtitle": "Modifica account, ruoli e permessi per {{username}}",
  "profile.userEditor.header.delete": "Elimina utente",
  "profile.userEditor.validation.displayNameRequired": "Il nome è obbligatorio",
  "profile.userEditor.validation.emailRequired": "L'email è obbligatoria",
  "profile.userEditor.validation.usernameRequired": "Lo username è obbligatorio",
  "profile.userEditor.validation.passwordRequired": "La password è obbligatoria",
  "profile.userEditor.validation.passwordMismatch": "Le password non coincidono",
  "profile.userEditor.validation.passwordWeak": "Password troppo debole: usa almeno 12 caratteri con maiuscole, numeri e simboli",
  "profile.userEditor.messages.saveSuccessCreate": "Utente creato con successo",
  "profile.userEditor.messages.saveSuccessUpdate": "Utente aggiornato con successo",
  "profile.userEditor.messages.saveError": "Errore durante il salvataggio",
  "profile.userEditor.messages.deleteSuccess": "Utente anonimizzato e disattivato",
  "profile.userEditor.messages.deleteError": "Errore durante l'eliminazione",
  "profile.userEditor.validation.deletePasswordRequired": "Inserisci la password per confermare l'operazione",
  "profile.userEditor.validation.deleteSecondFactorRequired": "Inserisci OTP o recovery code per continuare",
  "profile.userEditor.deleteDialog.title": "Conferma eliminazione utente",
  "profile.userEditor.deleteDialog.description": "L'operazione disattiva l'accesso e anonimizza i dati personali per conformita GDPR.",
  "profile.userEditor.deleteDialog.warning": "Operazione sensibile: conferma con password corrente e 2FA quando attiva.",
  "profile.userEditor.deleteDialog.passwordLabel": "Password corrente",
  "profile.userEditor.deleteDialog.passwordPlaceholder": "Inserisci la password",
  "profile.userEditor.deleteDialog.otpLabel": "Codice OTP (6 cifre)",
  "profile.userEditor.deleteDialog.otpPlaceholder": "Esempio: 123456",
  "profile.userEditor.deleteDialog.recoveryLabel": "Recovery code (alternativa)",
  "profile.userEditor.deleteDialog.recoveryPlaceholder": "Usa un recovery code se non hai OTP",
  "profile.userEditor.deleteDialog.cancel": "Annulla",
  "profile.userEditor.deleteDialog.confirm": "Elimina e anonimizza",
}

export default profileUserEditorMessages
